import React, { useContext, useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthContext from "../Context/auth/AuthContext";
import Spinner from "../components/loading/Spinner"; // Asumiendo que existe un Spinner

const AdminRoute = ({ component: Component, ...rest }) => {
    const { usuario, cargando, usuarioAutenticado } = useContext(AuthContext);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            const isEmpty = !usuario || Object.keys(usuario).length === 0;
            if (isEmpty && !cargando) {
                console.log("AdminRoute: User empty, fetching...");
                await usuarioAutenticado();
            }
            setChecking(false);
        };
        checkAuth();
    }, [usuario, cargando, usuarioAutenticado]);

    if (cargando || checking) {
        // Mostrar spinner mientras carga o verifica
        return <Spinner />;
    }

    return (
        <Route
            {...rest}
            render={(props) => {
                // Verificación basada en rol
                console.log("AdminRoute Check:", usuario);
                const role = usuario?.role;
                const type = usuario?.type_user;

                if (usuario && Object.keys(usuario).length > 0 && (role === "admin" || type === 0 || type === 1)) {
                    // Allowing type 1 temporarily based on user feedback if role is "admin"
                    if (role === "admin" || type === 0) {
                        return <Component {...props} />;
                    }
                    // Fallback if type 1 but role not admin? User provided data has both.
                    // If role is admin, we are good.
                    if (role === "admin") return <Component {...props} />;
                }

                console.warn("Acceso denegado. Redirigiendo...", usuario);
                return <Redirect to="/catalogo" />;
            }}
        />
    );
};

export default AdminRoute;
